import { PropsWithChildren } from 'react'
import { Alert, Row, AlertProps } from '@skedulo/breeze-ui-react'
import { ErrorLevel, UIErrorCode } from '../constants'
import { getErrorCTA, getErrorMessage } from '../utils'
import { ErrorDetail } from './error-detail'
import type { ErrorFallbackProps } from './error-fallback'
import type { AlertErrorLevel } from '../types'

export interface AlertErrorFallbackProps extends ErrorFallbackProps<AlertErrorLevel> {
  errorType?: AlertProps['type']
}

/**
 * Renders an alert-style layout to use as a fallback UI when a group or single
 * component in the application has broken, but surrounding components can still
 * be used.
 */
export const AlertErrorFallback = ({
  level = ErrorLevel.COMPONENT,
  code = UIErrorCode.UNKNOWN,
  traceId,
  supportEmail,
  errorType = 'error',
  error,
  children,
}: PropsWithChildren<AlertErrorFallbackProps>) => {
  return (
    <Row
      style={{
        fontSize: 'var(--brz-font-size)',
        fontWeight: 'var(--brz-font-weight-medium)',
        display: 'block',
        margin: 'var(--brz-spacing-5)',
      }}
    >
      <Alert type={errorType}>
        <ErrorDetail code={code} traceId={traceId} message={error?.message}>
          <>
            {children || getErrorMessage(level)}{' '}
            {getErrorCTA(level, code, traceId, supportEmail)}
          </>
        </ErrorDetail>
      </Alert>
    </Row>
  )
}
